import type { MenuBoardConfig, MenuBoardLayout, MenuInput, ScoredItem } from "../types.js";
import { chooseLayoutType, validateLayout } from "./rules.js";
import {
  buildCategoryScreens,
  buildGridOnlyScreens,
  buildHeroGridScreens,
} from "./screen-builder.js";

export function generateLayout(
  items: ScoredItem[],
  input: MenuInput,
  config: MenuBoardConfig,
): MenuBoardLayout {
  const layoutType = chooseLayoutType(input, config);

  let screens;
  switch (layoutType) {
    case "hero-grid": {
      screens = buildHeroGridScreens(items, config);
      break;
    }
    case "grid-only": {
      screens = buildGridOnlyScreens(items, config);
      break;
    }
    case "category-based": {
      screens = buildCategoryScreens(items, input.categories, config);
      break;
    }
  }

  const layout: MenuBoardLayout = {
    screens,
    totalItems: items.length,
    layoutType,
  };

  const errors = validateLayout(layout);
  if (errors.length > 0) {
    throw new Error(`Invalid layout: ${errors.join(", ")}`);
  }

  return layout;
}
